export type FeatureToggles = {
  liveGM?: boolean;
  committedCapital?: boolean;
  automatedDbotDecisions?: boolean;
  financialInstrumentOptions?: boolean;
  entityData?: boolean;
  trankDataSharing?: boolean;
  incorporation?: boolean;
  templates?: boolean;
};

export type PortfolioFeatureToggles = {
  search?: boolean;
  reports?: boolean;
};

export const sharesDataWithTRank = (featureToggles: FeatureToggles) =>
  featureToggles.trankDataSharing !== false;
